import { useEffect, useState } from 'react'
import { useAuth } from './auth.js'

/** Absent or failed means "not configured", so a broken probe never renders a dead button. */
export function useProviders(): { google: boolean } {
  const { api } = useAuth()
  const [providers, setProviders] = useState({ google: false })

  useEffect(() => {
    let live = true
    api
      .get<{ google: boolean }>('/api/auth/providers')
      .then((p) => {
        if (live) setProviders({ google: p.google === true })
      })
      .catch(() => {
        if (live) setProviders({ google: false })
      })
    return () => {
      live = false
    }
  }, [api])

  return providers
}
